import { useEffect, useState } from "react";
import { WifiOff, RefreshCw, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import { offlineQueue, flushOfflineQueue } from "@/lib/api";

export default function OfflineBanner() {
  const [off, setOff] = useState(typeof navigator !== "undefined" && !navigator.onLine);
  const [pending, setPending] = useState(offlineQueue().length);
  useEffect(() => {
    const on = () => setOff(false); const offF = () => setOff(true);
    const q = (e) => setPending(e.detail);
    const synced = (e) => { const { sent, failed } = e.detail || {}; if (sent) toast.success(`${sent} modification(s) hors connexion synchronisée(s)`); if (failed) toast.error(`${failed} modification(s) refusée(s) par le serveur`); setPending(offlineQueue().length); };
    window.addEventListener("online", on); window.addEventListener("offline", offF);
    window.addEventListener("ced-offline-queue", q); window.addEventListener("ced-offline-synced", synced);
    if (navigator.onLine && offlineQueue().length) flushOfflineQueue();
    return () => { window.removeEventListener("online", on); window.removeEventListener("offline", offF); window.removeEventListener("ced-offline-queue", q); window.removeEventListener("ced-offline-synced", synced); };
  }, []);
  if (!off && !pending) return null;
  return (
    <div className={`sticky top-0 z-40 text-xs font-medium px-4 py-2 flex flex-wrap items-center gap-2 ${off ? "bg-amber-500 text-black" : "bg-blue-600 text-white"}`} data-testid="offline-banner">
      {off ? <WifiOff className="w-4 h-4 shrink-0" /> : <CheckCircle2 className="w-4 h-4 shrink-0" />}
      <span className="flex-1 min-w-0">
        {off ? "Hors connexion : les pages déjà consultées restent disponibles. Vos modifications (RDV, état des lieux, fiches, tâches, clients) sont conservées sur cet appareil et seront envoyées au retour du réseau. E-mails et paiements indisponibles." : "Connexion rétablie."}
        {pending > 0 && <b data-testid="offline-pending"> {pending} modification(s) en attente de synchronisation.</b>}
      </span>
      {!off && pending > 0 && <button data-testid="offline-sync" onClick={() => flushOfflineQueue()} className="inline-flex items-center gap-1 rounded-full bg-white/20 px-3 py-1"><RefreshCw className="w-3.5 h-3.5" /> Synchroniser</button>}
    </div>
  );
}
